var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 340,
    viewBox: "0 0 361 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.65817V340H302.08L348.07 298.006C357.973 288.964 352.008 272.473 338.606 271.864L182.54 264.775C230.662 202.821 228.685 113.388 173.981 53.4778C128.652 3.83494 59.8466 -11.6013 0 8.65817Z",
    fill: "#FFE7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28.6785C61.3261 4.10288 134.073 18.4935 181.243 70.1521C235.613 129.697 237.579 218.585 189.75 280.162L188.566 281.687L190.494 281.774L346.561 288.863C359.072 289.432 364.641 304.826 355.396 313.268L326.12 340H327.603L356.07 314.006C365.973 304.964 360.008 288.473 346.606 287.864L191.761 280.831L190.54 280.775C190.79 280.454 191.038 280.131 191.285 279.808C238.641 217.893 236.401 129.077 181.981 69.4778C149.601 34.0159 105.241 16.009 60.7244 16C60.702 16 60.6797 16 60.6573 16C40.0812 16.0042 19.4729 19.8535 0 27.6015V28.6785Z",
    fill: "#FFA86D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftShapeRed);
export default __webpack_public_path__ + "static/media/bottom-left-shape-red.bd6d1c2d46baccf8c933326425d589bb.svg";
export { ForwardRef as ReactComponent };